const getSocialMediaLink = (mediaCode, url, text) => {
  let link = '';
  switch (mediaCode) {
    case 'fb':
      link = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        url
      )}&quote=${encodeURIComponent(text)}`;
      break;
    case 'tw':
      link = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        text
      )}&url=${encodeURIComponent(url)}`;
      break;
    case 'tg':
      link = `https://telegram.me/share/url?text=${encodeURIComponent(
        text
      )}&url=${encodeURIComponent(url)}`;
      break;
    case 'wa':
      link = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        text
      )}&url=${encodeURIComponent(url)}`;
      break;
    case 'li':
      link = `https://social-plugins.line.me/lineit/share?url=${encodeURIComponent(
        url
      )}&text=${encodeURIComponent(text)}`;
      break;
    case 'kk':
      link = `https://story.kakao.com/share?url=${encodeURIComponent(
        url
      )}&text=${encodeURIComponent(text)}`;
      break;
    case 'mg':
      link = `https://www.facebook.com/dialog/send?url=${encodeURIComponent(
        url
      )}&text=${encodeURIComponent(text)}`;
      break;
    case 'in':
      link = `https://www.linkedin.com/sharing/share-offsite?url=${encodeURIComponent(
        url
      )}`;
      break;
    case 'vk':
      link = `https://vk.com/share.php?url=${encodeURIComponent(
        url
      )}&comment=${encodeURIComponent(text)}`;
      break;
    case 'ok':
      link = `https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&st.title=${encodeURIComponent(
        text
      )}&st.shareUrl=${encodeURIComponent(url)}`;
      break;
    case 'nv':
      link = `https://share.naver.com/web/shareView.nhn?url=${encodeURIComponent(
        url
      )}&title=${encodeURIComponent(text)}`;
      break;
    case 'bd-tw':
      link = `https://twitter.com/${url}`;
      // link = 'https://twitter.com/' + '{{ $bd_info->twitter }}';
      break;
    case 'bd-tg':
      link = `https://t.me/'${url}`;
      // link = 'https://t.me/' + '{{ $bd_info->telegram }}';
      break;
    case 'bd-wa':
      link = `https://wa.me/'${url}`;
      // link = 'https://wa.me/' + '{{ $bd_info->whatsapp }}';
      break;
    case 'bd-mail':
      // link = 'mailto:' + '{{ $bd_info->email }}';
      link = `mailto:${url}`;
      break;
  }

  return link;
};

export const centeredPopup = (mediaCode, winName, link, title) => {
  const w = 800;
  const h = 600;
  const scroll = 'yes';

  const url = getSocialMediaLink(mediaCode, link, title);

  const LeftPosition = window.screen.width ? (window.screen.width - w) / 2 : 0;
  const TopPosition = window.screen.height ? (window.screen.height - h) / 2 : 0;
  const settings =
    'height=' +
    h +
    ',width=' +
    w +
    ',top=' +
    TopPosition +
    ',left=' +
    LeftPosition +
    ',scrollbars=' +
    scroll +
    ',resizable';
  window.open(url, winName, settings);
};

export const openNewTab = (e, mediaCode, winName, link) => {
  const url = getSocialMediaLink(mediaCode, link, '');

  window.open(url, winName);
};
